import React, {Component} from 'react';
import {getDaysAgo, getFormattedDateForTitle} from "../../../../utils/date";
import RecordingOptionsDropdownMenu from "./RecordingOptionsDropdownMenu";
import PriorityLevel from "./information/PriorityLevels";
import PrivacyLevels from "./information/PrivacyLevels";
import {byPropKey} from "../../../utils";
import Modal from "react-responsive-modal";
import PlaybackVideoPlayer from "./playback/PlaybackVideoPlayer";
import UnreadAlert from "./information/UnreadAlert";
import Speed from "./information/Speed";
import Size from "./information/Size";
import {dbase} from "../../../../firebase";
import {showReadRecordingNotification} from "../../../notifications/live";
import {getFormattedRecordingTitle, getFormattedRouteForRecordingViewForSharing} from "../utils";
import Runtime from "./information/Runtime";
import {getUnitID, getUnitName} from "../../utils";
import {FadeInOut} from 'react-animation-components';

export const STYLE_RECORDING_CARD_INFO_ITEM = {
    float: 'left',
    marginRight: '10px',
    fontSize: '85%'
};

/**
 * A single component that encapsulates the recording card.
 */
class RecordingCard extends Component {
    constructor() {
        super();
        this.state = {
            openModal: false,
            isUnread: true,
            in: false
        };
    }

    componentWillMount() {
        if (this.props.animationTimeout) {
            setTimeout(() => {
                this.setState(byPropKey('in', true));
            }, this.props.animationTimeout);
        } else {
            this.setState(byPropKey('in', true));
        }
    }

    onPlayButtonClick = () => {
        this.setState(byPropKey('openModal', true));
    };

    onCloseModal = () => {
        this.setState(byPropKey('openModal', false));
    };

    onCardClick = () => {
        if (this.isUnread()) {
            this.setState(byPropKey('isUnread', false));
            dbase.setRecordingIsRead(getUnitID(this.props.selectedUnit), this.props.recordingID)
                .then(showReadRecordingNotification);
        }
    };

    /**
     * @returns {boolean} {@code true} if the
     * recording has not been read yet.
     * The behaviour defaults to unread if the
     * key {@code isUnread} is not present in
     * {@code recordingData}.
     */
    isUnread = () => {
        return (!('isUnread' in this.props.recordingData) || this.props.recordingData.isUnread)
            && this.state.isUnread;
    };

    render() {
        const title = getFormattedRecordingTitle(this.props.recordingData);
        const thumbnailURL = this.props.recordingData.thumbnailURL;
        const dropdownOptionID = "recordingDropdown" + this.props.recordingID;
        const recordingUrl = getFormattedRouteForRecordingViewForSharing(getUnitID(this.props.selectedUnit), this.props.recordingID);
        const isUnread = this.isUnread();
        // TODO: Move close button to "absolute/fixed position" relative to top right of screen.
        return (
            <div className="col-lg-4 col-md-6 col-sm-12 col-xs-12">
                <FadeInOut in={this.state.in}>
                    <Modal
                        open={this.state.openModal}
                        onClose={this.onCloseModal}
                        showCloseIcon
                        classNames={{
                            overlay: 'recordings-modal-overlay',
                            modal: 'recordings-modal',
                            closeIcon: 'recordings-modal-closeIcon'
                        }}
                    >
                        <PlaybackVideoPlayer
                            title={title}
                            date={this.props.recordingData.date}
                            description={this.props.recordingData.description}
                            thumbnailURL={thumbnailURL}
                            URL={this.props.recordingData.wowzaURL}
                            backupURL={this.props.recordingData.wowzaURL2}
                            carName={getUnitName(this.props.selectedUnit)}
                            privacy={this.props.recordingData.privacy}
                            rawPriority={this.props.recordingData.priority}
                            runtime={this.props.recordingData.runtime}
                            size={this.props.recordingData.size}
                            speed={this.props.recordingData.speed}
                            recordingUrl={recordingUrl}
                            unitID={getUnitID(this.props.selectedUnit)}
                            recordingID={this.props.recordingID}
                        />
                    </Modal>
                    <div className="card" style={{marginTop: '15px', marginBottom: '15px'}} onClick={this.onCardClick}>
                        <div
                            className="card-img-top text-center"
                            style={{backgroundImage: 'url(' + thumbnailURL + ')', backgroundSize: 'cover', minHeight: '168px'}}
                        >
                            <button
                                type="button"
                                className="btn btn-light btn-lg"
                                style={{opacity: '0.7', borderRadius: '50%', height: '50px', width: '50px', marginTop: '59px'}}
                                onClick={this.onPlayButtonClick}
                            >
                                <i className="fas fa-play" />
                            </button>
                            <Runtime runtime={this.props.recordingData.runtime}/>
                        </div>

                        <div className="card-body">
                            <div className="mb-2">
                                {isUnread && <UnreadAlert/>}
                                <h5 className="card-title mb-0">{title}</h5>
                                <div className="text-muted small">{getFormattedDateForTitle(this.props.recordingData.date)}</div>
                            </div>
                            <div className="row text-center">
                                <div className="col-12"><PriorityLevel rawPriority={this.props.recordingData.priority} /></div>
                            </div>
                            <PrivacyLevels rawPrivacy={this.props.recordingData.privacy} />
                            <Speed speed={this.props.recordingData.speed}/>
                            <Size size={this.props.recordingData.size}/>
                            <div className="btn-group dropup" style={{width: '100%'}}>
                                <p className="card-text mt-1" style={{marginBottom: 0, paddingRight: '5px', lineHeight: '100%'}}>
                                    <small className="text-muted">
                                        Uploaded from {getUnitName(this.props.selectedUnit) + " " + getDaysAgo(this.props.recordingData.date)} ago
                                    </small>
                                </p>
                                <button
                                    type="button"
                                    className="btn btn-outline-dark btn-sm ml-auto"
                                    style={{opacity: '0.75', border: '1px transparent', borderRadius: '50%', maxHeight: '40px', maxWidth: '41px', minHeight: '40px', minWidth: '40px'}}
                                    id={dropdownOptionID}
                                    data-toggle="dropdown"
                                    aria-haspopup="true"
                                    aria-expanded="false"
                                >
                                    <i className="fas fa-ellipsis-v" />
                                </button>
                                <RecordingOptionsDropdownMenu
                                    dropdownOptionID={dropdownOptionID}
                                    selectedUnitID={getUnitID(this.props.selectedUnit)}
                                    recordingID={this.props.recordingID}
                                    recordingData={this.props.recordingData}
                                />
                            </div>
                        </div>
                    </div>
                </FadeInOut>
            </div>
        );
    }
}

export default RecordingCard;



// WEBPACK FOOTER //
// ./src/components/unit/recordings/recordingcard/RecordingCard.jsx